import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider, useSelector } from 'react-redux';
import { AnimatePresence } from 'framer-motion';
import store from './store';
import Home from './pages/Home';
import Quiz from './pages/Quiz';
import Benefits from './pages/Benefits';
import Nearby from './pages/Nearby';
import Booking from './pages/Booking';
import Success from './pages/Success';
import LoginRegister from './pages/LoginRegister';
import DashboardUser from './pages/DashboardUser';
import DashboardPartner from './pages/DashboardPartner';
import socketService from './utils/socket';
import { requestNotificationPermission } from './utils/firebase';

// Protected Route Component
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, user } = useSelector((state) => state.user);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function AppContent() {
  const { isAuthenticated, user } = useSelector((state) => state.user);

  useEffect(() => {
    // Initialize socket connection for authenticated users
    if (isAuthenticated && user) {
      socketService.connect(user.id, user.role);

      // Request notification permission
      requestNotificationPermission().then((token) => {
        if (token) {
          console.log('FCM Token:', token);
          // Send token to backend to store
        }
      });

      return () => {
        socketService.disconnect();
      };
    }
  }, [isAuthenticated, user]);

  return (
    <AnimatePresence mode="wait">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/benefits" element={<Benefits />} />
        <Route path="/nearby" element={<Nearby />} />
        <Route path="/booking/:partnerId" element={<Booking />} />
        <Route path="/success" element={<Success />} />
        <Route path="/login" element={<LoginRegister />} />
        
        {/* Protected Routes */}
        <Route
          path="/dashboard/user"
          element={
            <ProtectedRoute allowedRoles={['user']}>
              <DashboardUser />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/partner"
          element={
            <ProtectedRoute allowedRoles={['partner']}>
              <DashboardPartner />
            </ProtectedRoute>
          }
        />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AppContent />
      </Router>
    </Provider>
  );
}

export default App;
